import { DateValue } from '@internationalized/date';

// Typing for the search form
export type FilterFormValues = {
    destination: string[];
    theme: string[];
    startDate: DateValue | undefined;
    endDate: DateValue | undefined;
    flexibility: number;
    nbPax: string;
    // adults: string;
    // children: string;
    // childrenAges: string[];
    levels: string[];
    types: string[];
    tags: string[];
    budgetMin: number;
    budgetMax: number;
    durationMin: number;
    durationMax: number;
};

// Typing for the label displayed
export type FilterFormLabels = {
    destination: string[];
    theme: string[];
    startDate: DateValue | undefined;
    endDate: DateValue | undefined;
    nbPax: string;
    levels: string;
    types: string;
    tags: string;
    budget: string;
    duration: string;
};

// used for mobile modal options listing
export enum FilterType {
    SELECTION,
    DESTINATION,
    SPORT,
    STARTDATE,
    PAX,
    LEVELS,
    TYPES,
    TAGS,
    BUDGET,
    DURATION,
}

// typing for param passed from the url
export type SearchForm = {
    // if coming from menu, its int, if from search, its string -> TODO fix in SearchFormModel ?
    destinations: number[] | string[] | null;
    sports: number[] | string[] | null;
    flexibility: number | null;
    nbPax: number | null;
    groupOnly: boolean;
    startDate: { date: string } | null;
    endDate: { date: string } | null;
    levels: string[];
    types: string[];
    tags: string[];
    budgetMin: number;
    budgetMax: number;
    durationMin: number;
    durationMax: number;
    sort: string;
};

export type PaxFilterValues = {
    adultsValue: string;
    childrenValue: string;
    childrenAges: string[];
};

export enum Sorting {
    DEFAULT = 'default',
    PRICE_ASC = 'price_asc',
    PRICE_DESC = 'price_desc',
    DURATION_DESC = 'duration_desc',
    DURATION_ASC = 'duration_asc',
    REVIEWS_DESC = 'reviews_desc',
    DEPARTURE_DATE = 'departure_date',
}
